export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = `page=${params.page}&limit=${params.limit}`;

  params.Descripcion &&
    (path = `${path !== '' ? `${path}&` : ''}Descripcion=${params.Descripcion}`);
  params.CodigoSecundario &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoSecundario=${params.CodigoSecundario}`);
  params.CodigoEjecutivo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEjecutivo=${params.CodigoEjecutivo}`);

  return path;
};
